@if(isShowDotsMenu()){
<a class="tw-cursor-pointer">
  <i class="mdi mdi-dots-vertical text-navyBlue mdi-20px"></i>
</a>
} @else{
<div
  class="tw-border-b tw-p-2.5 dark:tw-border-dark-100 tw-cursor-pointer hover:!tw-bg-gray-100 dark:hover:!tw-bg-[#3b3b55] tw-flex-start"
  [class]="btnColor()"
>
  <!-- icon  -->
  <i
    class="mdi tw-ml-[6px] ltr:tw-mr-[6px]"
    [class]="btnIcon() + ' ' + btnColor()"
  ></i>
  <!-- title  -->
  <span class="mat-menu-title tw-font-medium tw-text-[13px]">{{
    btnTitle() | translate
  }}</span>
</div>
}
